module.exports = __webpack_public_path__ + "img/duibi12.2a497de1.png";